module.exports = __webpack_public_path__ + "files/e900c6cf9197e19d6c14fd51e2b350f1.png";